import * as React from "react";
import { Redirect, Route } from "react-router-dom";

interface IProps {
    exact: true;
    path: string;
    component: (props: any) => JSX.Element;
    isLoggedIn: boolean;
}

export const ProtectedRoute: React.FunctionComponent<IProps> = (
    protProps: IProps
): JSX.Element => {
    const { isLoggedIn, component: Component, ...rest } = protProps;
    return (
        <Route
            {...rest}
            render={(routeProps) => {
                return (
                    <>
                        {isLoggedIn ? (
                            <Component {...rest} {...routeProps} />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                    state: { from: routeProps.location },
                                }}
                            />
                        )}
                    </>
                );
            }}
        />
    );
};
